import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';
import { CATEGORY_IMAGES } from '@/data/images';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {t('home.categoriesSection.title')}
          </h2>
          <p className="mt-3 text-foreground-600">{t('home.categoriesSection.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="w-full h-28 md:h-36 overflow-hidden">
                <img
                  src={CATEGORY_IMAGES[c.id]}
                  alt={t(c.nameKey)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-4">
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors leading-tight">
                  {t(c.nameKey)}
                </span>
                <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-500">
                  {t('buttons.viewAll')}
                  <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}